import { Routes } from "@angular/router";

import { AndrewsPageComponent } from "../andrews-page/andrews-page.component";

import { IsLoggedIn } from '../shared/guards/is-logged-in';

export const routes: Routes = [
  { path: "andrews", component: AndrewsPageComponent, canActivate: [IsLoggedIn] }
];



// WEBPACK FOOTER //
// ./src/app/routes/andrews.route.ts